import { EMenuActionsTypes } from '@enums/common';

export const searchTooltipText = 'Search by branch';
export const BRANCH_TABLE_SIZE = '80%';
export const HISTORY_CHECK_OPTIONS_WIDTH = '400px';
export const historyCheckTitle = 'History Check';
export const exportBranchTooltip = 'Export Summary to Excel';
export const datePickerErrorText = `From date should be less that To date`;
export const emptyTableText = 'Select options and apply MO Branches';
export const emptyTableTextAwtgRan = 'Select options and apply';

export const exportActionsHistoryCheckBranches = [
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
];

